// Column ids for the apply-CoA-template select-entities table. The table uses
// the dedicated `ViewType.CHART_OF_ACCOUNTS_TEMPLATE_APPLY` (so it doesn't
// collide with the templates-list view) but is ephemeral — held in local state,
// never persisted or cached — so it doesn't need a discriminated-union view
// schema for runtime validation.
export enum ChartOfAccountsTemplateApplyEntityColumn {
    NAME = "name",
    INDUSTRY = "industry",
    LAST_UPDATED = "lastUpdated",
    TEAM = "team",
    SERVICES = "services",
    BASIS = "basis",
    // Date the template was applied to the entity. Rendered only by the
    // applied-entities drawer (its view lists this column); hidden elsewhere.
    APPLIED_AT = "appliedAt",
    // Pinned-right "Open" action, rendered only by the applied-entities drawer
    // (its view lists this column). The apply wizard's view omits it, and it is
    // hidden from column settings, so it never shows there.
    OPEN = "open",
}
